/**
 * Harmony Oud — Theme JS
 * Header scroll state, mobile menu, language switcher, misc UI.
 */
(function () {
  'use strict';

  // ── Header scroll state ───────────────────────────────────────────────────
  var header = document.getElementById('site-header');
  var annoBar = document.getElementById('announcement-bar');
  var headerScrollTick = false;

  function onHeaderScroll() {
    if (!header) return;
    if (headerScrollTick) return;
    headerScrollTick = true;
    window.requestAnimationFrame(function () {
      header.classList.toggle('scrolled', window.scrollY > 24);
      headerScrollTick = false;
    });
  }
  window.addEventListener('scroll', onHeaderScroll, { passive: true });
  onHeaderScroll();

  // ── Announcement bar close ────────────────────────────────────────────────
  var annoClose = document.getElementById('announcement-close');
  if (annoClose && annoBar) {
    annoClose.addEventListener('click', function () {
      annoBar.style.transition = 'max-height 300ms ease, opacity 300ms ease, padding 300ms ease';
      annoBar.style.maxHeight  = '0';
      annoBar.style.opacity    = '0';
      annoBar.style.paddingTop    = '0';
      annoBar.style.paddingBottom = '0';
      sessionStorage.setItem('annoBarClosed', '1');
    });
    if (sessionStorage.getItem('annoBarClosed')) annoBar.style.display = 'none';
  }

  // ── Mobile menu ───────────────────────────────────────────────────────────
  var menuOpen  = document.getElementById('mobile-menu-open');
  var menuClose = document.getElementById('mobile-menu-close');
  var mobileMenu = document.getElementById('mobile-menu');
  var menuBackdrop = document.getElementById('mobile-menu-backdrop');
  var menuFocusables = [];
  var lastActiveElement = null;

  function refreshMenuFocusables() {
    if (!mobileMenu) return;
    menuFocusables = Array.prototype.slice.call(
      mobileMenu.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])')
    );
  }

  function openMenu() {
    if (!mobileMenu) return;
    lastActiveElement = document.activeElement;
    mobileMenu.classList.add('open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (menuOpen) menuOpen.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    refreshMenuFocusables();
    if (menuFocusables.length) menuFocusables[0].focus();
  }
  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (menuOpen) menuOpen.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
      lastActiveElement.focus();
    }
  }
  menuOpen  && menuOpen.addEventListener('click', openMenu);
  menuClose && menuClose.addEventListener('click', closeMenu);
  menuBackdrop && menuBackdrop.addEventListener('click', closeMenu);
  document.querySelectorAll('[data-mobile-nav-link]').forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
    if (e.key === 'Tab' && mobileMenu && mobileMenu.classList.contains('open')) {
      refreshMenuFocusables();
      if (!menuFocusables.length) return;
      var first = menuFocusables[0];
      var last = menuFocusables[menuFocusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // ── Language switcher dropdown ────────────────────────────────────────────
  var langBtn      = document.getElementById('lang-switcher-btn');
  var langDropdown = document.getElementById('lang-dropdown');

  if (langBtn && langDropdown) {
    langBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = langDropdown.style.display === 'block';
      langDropdown.style.display = open ? 'none' : 'block';
    });
    document.addEventListener('click', function () {
      if (langDropdown) langDropdown.style.display = 'none';
    });
  }

  // ── Smooth scroll for anchor links ───────────────────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href');
      if (!href || href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ── Intersection observer: fade-in on scroll ──────────────────────────────
  var fadeEls = document.querySelectorAll('[data-fade]');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (fadeEls.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      // No animation: show everything immediately.
      fadeEls.forEach(function (el) { el.classList.add('visible'); });
    } else {
      var style = document.createElement('style');
      style.textContent =
        '[data-fade]{opacity:0;transform:translateY(16px);' +
        'transition:opacity 350ms cubic-bezier(0.16,1,0.3,1),transform 350ms cubic-bezier(0.16,1,0.3,1);' +
        'will-change:opacity,transform}' +
        '[data-fade].visible{opacity:1;transform:none}';
      document.head.appendChild(style);

      // Stagger each fade element by its order within its section.
      fadeEls.forEach(function (el) {
        var sec = el.closest('section');
        var idx = 0;
        if (sec) {
          var sibs = sec.querySelectorAll('[data-fade]');
          idx = Math.min(Array.prototype.indexOf.call(sibs, el), 5);
        }
        el.dataset.fadeOrder = idx;
      });

      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.style.transitionDelay = (parseInt(en.target.dataset.fadeOrder, 10) || 0) * 60 + 'ms';
            en.target.classList.add('visible');
            obs.unobserve(en.target);
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px 12% 0px' });

      fadeEls.forEach(function (el) { obs.observe(el); });
    }
  }

})();
;/* Harmony Oud: sepet sayfası — adet butonları ve otomatik güncelleme (Revize) */
(function () {
  'use strict';
  var section = document.querySelector('[data-cart-section]');
  if (!section) return;
  var sectionId = section.getAttribute('data-cart-section');
  var statusEl = section.querySelector('[data-cart-status]');
  var t = (window.HarmonyOud && window.HarmonyOud.t) || {};
  var timers = {};

  function setStatus(message) { if (statusEl) statusEl.textContent = message || ''; }

  function updateCounts(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function change(key, qty) {
    var itemsEl = section.querySelector('.cart-page__items');
    if (itemsEl) itemsEl.classList.add('is-updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: sectionId, sections_url: window.location.pathname.charAt(0) === '/' ? window.location.pathname : '/cart' })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      })
      .then(function (cart) {
        var html = cart.sections && cart.sections[sectionId];
        if (cart.item_count === 0 || !html) { window.location.reload(); return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.cart-page__items');
        if (fresh && itemsEl) { itemsEl.replaceWith(fresh); enhance(fresh); }
        var subtotal = doc.querySelector('[data-cart-subtotal]');
        if (subtotal) {
          section.querySelectorAll('[data-cart-subtotal]').forEach(function (el) { el.innerHTML = subtotal.innerHTML; });
        }
        updateCounts(cart.item_count);
        setStatus('');
      })
      .catch(function (error) {
        console.error('Cart update error', error);
        if (itemsEl) itemsEl.classList.remove('is-updating');
        setStatus(t.cart_error || 'Bir sorun oluştu. Lütfen tekrar deneyin.');
      });
  }

  function queue(input) {
    var key = input.dataset.key;
    if (!key) return;
    window.clearTimeout(timers[key]);
    timers[key] = window.setTimeout(function () {
      change(key, Math.max(1, parseInt(input.value, 10) || 1));
    }, 450);
  }

  function enhance(root) {
    root.querySelectorAll('.cart-page__qty').forEach(function (input) {
      if (input.closest('.ho-qty')) return;
      var wrap = document.createElement('div');
      wrap.className = 'ho-qty';
      var minus = document.createElement('button');
      minus.type = 'button';
      minus.textContent = '−';
      minus.setAttribute('aria-label', t.cart_decrease || 'Adedi azalt');
      var plus = document.createElement('button');
      plus.type = 'button';
      plus.textContent = '+';
      plus.setAttribute('aria-label', t.cart_increase || 'Adedi artır');
      input.parentNode.insertBefore(wrap, input);
      wrap.appendChild(minus);
      wrap.appendChild(input);
      wrap.appendChild(plus);
      input.min = '1';
      input.setAttribute('inputmode', 'numeric');
      function value() { return parseInt(input.value, 10) || 1; }
      function sync() { minus.disabled = value() <= 1; }
      sync();
      minus.addEventListener('click', function () {
        if (value() > 1) { input.value = value() - 1; sync(); queue(input); }
      });
      plus.addEventListener('click', function () { input.value = value() + 1; sync(); queue(input); });
      input.addEventListener('change', function () {
        if (value() < 1) input.value = 1;
        sync();
        queue(input);
      });
      var remove = document.createElement('a');
      remove.className = 'ho-remove';
      remove.href = '/cart/change?line=' + input.dataset.line + '&quantity=0';
      remove.textContent = t.cart_remove || 'Kaldır';
      remove.addEventListener('click', function (event) {
        event.preventDefault();
        change(input.dataset.key, 0);
      });
      (input.closest('.cart-page__item-info') || wrap.parentNode).appendChild(remove);
    });
  }

  enhance(section);

  // Mobil ödeme çubuğu: asıl "Ödemeye geç" butonu görünürken gizle.
  var bar = section.querySelector('[data-cart-stickybar]');
  var mainButton = section.querySelector('[data-cart-checkout]');
  if (bar && mainButton && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-hidden', entries[0].isIntersecting);
    }).observe(mainButton);
  }
})();

/* Footer: mobilde açılır kolonlar (Revize) */
(function () {
  var cols = document.querySelectorAll('.site-footer__col');
  if (!cols.length || !window.matchMedia) return;
  var mq = window.matchMedia('(min-width: 768px)');
  function sync() { cols.forEach(function (col) { col.open = mq.matches; }); }
  cols.forEach(function (col) {
    col.addEventListener('toggle', function () { if (mq.matches && !col.open) col.open = true; });
  });
  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
})();
/* Duyuru cubugu acikken sabit ust menuyu cubugun altina al */(function(){var b=document.getElementById('announcement-bar'),h=document.getElementById('site-header');if(!b||!h)return;function u(){var hidden=getComputedStyle(b).display==='none'||b.style.maxHeight==='0px'||b.style.maxHeight==='0';var v=hidden?0:b.offsetHeight;h.style.top=Math.max(0,v-window.scrollY)+'px';}u();window.addEventListener('scroll',u,{passive:true});window.addEventListener('resize',u);var c=document.getElementById('announcement-close');c&&c.addEventListener('click',function(){setTimeout(u,320)});})();